var exports = {
  "k": "xcc377c0b--89f51a--container",
  "m": "xcc377c0b--89f51a--reaction",
};

module.exports = exports;
